import { createFileRoute } from '@tanstack/react-router';

import { ModeSelectionStep } from '@/features/onboarding/components/steps/lf/modeSelectionStep';

export const Route = createFileRoute(
  '/_protected/onboarding/_steps/mode-selection',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <ModeSelectionStep />;
}
